import { create } from 'zustand';

import { IOnboardingDataCompanyForm } from '../schemas';

interface IDataState {
  onboardingDataCompanyForm: IOnboardingDataCompanyForm;
  setOnboardingDataCompanyForm: (DataState: IOnboardingDataCompanyForm) => void;
}

export const useDataState = create<IDataState>(set => {
  return {
    onboardingDataCompanyForm: sessionStorage.getItem(
      'onboardingDataCompanyForm',
    )
      ? JSON.parse(sessionStorage.getItem('onboardingDataCompanyForm')!)
      : ({} as IOnboardingDataCompanyForm),
    setOnboardingDataCompanyForm(newData: IOnboardingDataCompanyForm) {
      set({ onboardingDataCompanyForm: newData });
      sessionStorage.setItem(
        'onboardingDataCompanyForm',
        JSON.stringify(newData),
      );
    },
  };
});
